import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { socket } from "../../utils/socket";
import { XCircleIcon } from "@heroicons/react/24/solid";

const Notification = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = user?.userId;

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userId) return;

    // Ensure socket is connected
    if (!socket.connected) {
      socket.connect();
    }

    console.log("Joined socket room:", userId);
    socket.emit("join", userId);

    const handleNotification = (data) => {
      console.log("New Notification Received:", data);

      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), message: data.message },
      ]);

      setTimeout(() => {
        setNotifications((prev) => prev.filter((n) => n.id !== data.id));
      }, 5000);
    };

    // Attach event listeners
    socket.on("booking confirmed", handleNotification);
    socket.on("booking accepted", handleNotification);
    socket.on("booking paused", handleNotification);
    socket.on("booking completed", handleNotification);
    socket.on("booking cancelled", handleNotification);

    // Cleanup function to remove listeners on unmount
    return () => {
      socket.off("booking confirmed", handleNotification);
      socket.off("booking accepted", handleNotification);
      socket.on("booking paused", handleNotification);
      socket.on("booking completed", handleNotification);
      socket.off("booking cancelled", handleNotification);
      socket.disconnect();
    };
  }, [userId]);  

  return (
    <div className="fixed bottom-5 right-5 space-y-2 z-50">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-lg flex items-center space-x-4"
          >
            <p className="text-sm font-medium">{notification.message}</p>
            <button
              onClick={() =>
                setNotifications((prev) =>
                  prev.filter((n) => n.id !== notification.id)
                )
              }
            >
              <XCircleIcon className="w-5 h-5 text-white hover:text-gray-300 transition duration-200" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Notification;
